<template>
  <b-container class= "container-fluid" fluid>
        <app-header />
        <div class="home-wrapper">
          <div class="side-bar" id="sticky-sidebar">
                <Sidebar />
          </div>

          <div class="col-m-8 home" id="main">
              <router-view/>
            
          </div>
        </div>
        <div class="footer_text">
            <v-divider></v-divider>
              <p class="footer">Created by: <a href='http://www.twitter.com/singamnv'>Sarma Singam MD</a>. This work is licensed under a Creative Commons Attribution 4.0 International License</p>
            <v-divider class="bottom-divider"></v-divider>
        </div>
        <div class="bottom-bar" >
              <b-dropdown squared id="dropdown-dropup" dropup text="Guide" variant="primary" class="m-0 bottom-button">
                <b-dropdown-item :to="{name: 'generalLink'}" >General </b-dropdown-item>
                <b-dropdown-item :to="{name: 'interventionalLink'}" >Interventional</b-dropdown-item>
                <b-dropdown-item :to="{name: 'advimgLink'}" >Advanced Imaging</b-dropdown-item>
                <b-dropdown-item :to="{name: 'epLink'}" >Electrophysiology</b-dropdown-item>
                <b-dropdown-item :to="{name: 'advhfLink'}" >Advance HF/Txp</b-dropdown-item>
                <b-dropdown-item :to="{name: 'cccLink'}" >Critical Care</b-dropdown-item>
                <b-dropdown-item v-show=false :to="{name: 'algorithmsLink'}" >Algorithms</b-dropdown-item>
                <b-dropdown-item v-show=false :to="{name: 'noncardsLink'}" >Non-cardiology</b-dropdown-item>
                <b-dropdown-item v-show=false :to="{name: 'otherLink'}" >Other</b-dropdown-item>

              </b-dropdown>
          </div>
        
  </b-container>
</template>

<script>
  import Header from './components/Header'
  import Sidebar from './components/Sidebar'
 

  import { 
  dbGeneralRef,
  dbInterventionalRef,
  dbEpRef,
  dbAdvImgRef,
  dbAdvHfRef,
  dbAlgorithmRef,
  dbNonCardsRef,
  dbOthersRef,
  dbAboutRef,
  dbHomeRef,
  dbCccRef,
  dbAdvocacyRef,
  dbTeamRef,
} from "./firebase";


  export default {
  name: 'App',
  components: {
    appHeader: Header,
    Sidebar,

  },
      
  created() {
      this.$store.dispatch('setGeneralRef',dbGeneralRef)
      this.$store.dispatch('setInterventionalRef',dbInterventionalRef)
      this.$store.dispatch('setEpRef',dbEpRef)
      this.$store.dispatch('setAdvImgRef',dbAdvImgRef)
      this.$store.dispatch('setAdvHfRef',dbAdvHfRef)
      this.$store.dispatch('setAlgorithmRef',dbAlgorithmRef)
      this.$store.dispatch('setNonCardsRef',dbNonCardsRef)
      this.$store.dispatch('setOthersRef',dbOthersRef)
      this.$store.dispatch('setAboutRef',dbAboutRef)
      this.$store.dispatch('setHomeRef',dbHomeRef)
      this.$store.dispatch('setCccRef',dbCccRef)
      this.$store.dispatch('setTeamRef',dbTeamRef)
      this.$store.dispatch('setAdvocacyRef',dbAdvocacyRef)


    }
  }
  

</script>

<style>

  .container-fluid {
    padding-left:0px;
  }

  .footer{
    font-size:0.7em;
    text-align: center;
    
  }

  .footer_text{
    padding-left:26vw;
    width: 100vw;
  }

 

  .side-bar{
    top: 55px;
    bottom:5px;
    position:fixed;
    overflow-y:scroll;
    overflow-x:hidden;
    width:auto;
    max-width:20vw;
  }

 

    .bottom-bar {
      position: fixed;
      left: 0;
      bottom:0;
      width: 100%;
      background-color: white;
   }

   .bottom-button{
     width:100%;
   }

    .show > .btn-primary.dropdown-toggle {
      background: linear-gradient(#e11127,#c10e21);
      border-color:#c10e21;
      border-radius:0;
      height:60px;

   }
    .btn-primary.dropdown-toggle {
      background: linear-gradient(#e11127,#c10e21);
      border-color: #c10e21;
      border-radius:0;
      height:60px;
      
   }

    .home-wrapper {
        padding-top:51px;
        
        display: flex;
        flex-direction: row;
    }

    .home {
      text-align: center;
    }

    @media screen and (max-width: 991px){
      .side-bar {
            display: none;
        }

        .footer_text{
          padding-left: 5px;
          width: 100vw;
          padding-right: 5px;
        }

        .bottom-divider{
          padding-bottom: 30px;
        }

        .home-wrapper{
          padding-top: 2em;
        }

      }
    @media screen and (min-width: 992px){
          .bottom-bar {
            display: none;
      }
      }

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>

